import api from './api';

export default {
    async getDataMensageByInquiryId(accessToken, id) {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json', 
            };
            const response = await api.get(`/message/inquiry/${id}?linesPerPage=100`, {
                method: 'GET',
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao obter dados da Resposta:', error);
            throw error;
        }
    },
    
    async createNewMessage(payload, id, accessToken){
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json', 
            };
            const response = await api.post(`/message/inquiry/${id}`, payload, {
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao obter dados da Resposta:', error);
            throw error;
        }
    }
}

